/**
 * English false friends and calques found in a learner's text (EE, EO transcript, tutor message):
 * the doubtful excerpt, the real French meaning, the right word and an example (D-094).
 */

import type { FalseFriendHit } from "@agencyos/api-client";
import { Badge } from "@agencyos/ui-web";
import { useTranslation } from "react-i18next";

import "./tutor.css";

export function FalseFriendsList({ hits, titled = true }: { hits: FalseFriendHit[]; titled?: boolean }) {
  const { t } = useTranslation();
  if (!hits.length) return null;
  return (
    <div className="stack tutor-ff" data-testid="false-friends">
      {titled && (
        <h4 className="ac-label">
          {t("academyTutor.ff.title")} · {t("academyTutor.ff.count", { count: hits.length })}
        </h4>
      )}
      <ul className="plain-list stack">
        {hits.map((hit) => (
          <li key={`${hit.id}-${hit.start}`} className={`tutor-ff__row tutor-ff__row--${hit.severity}`}>
            <p className="ac-ff__head">
              <Badge tone={hit.severity === "error" ? "danger" : "offer"}>{t(`academyTutor.ff.severity.${hit.severity}`)}</Badge>
              <Badge>{t(`academyTutor.ff.kind.${hit.kind}`)}</Badge>
              <strong lang="fr">« {hit.excerpt} »</strong>
            </p>
            {hit.kind !== "english" && <p className="ac-small">{t("academyTutor.ff.pair", { french: hit.french, english: hit.english })}</p>}
            <p className="ac-small">{t("academyTutor.ff.meaning", { meaning: hit.meaning })}</p>
            <p className="ac-small">{t("academyTutor.ff.correct", { english: hit.english, correct: hit.correct })}</p>
            <p className="ac-footnote" lang="fr">
              {t("academyTutor.ff.example", { example: hit.example })}
            </p>
          </li>
        ))}
      </ul>
    </div>
  );
}
